module.exports = __webpack_public_path__ + "img/C4.81017112.png";